import { View } from 'react-native';
import DropDownPicker from 'react-native-dropdown-picker';
import { themes } from '../../design/colors';
import { ItemsSelects } from '../../utils/types';

interface CustomDropDownProps {
  open: boolean;
  value: any;
  placeholder: string;
  items: ItemsSelects[];
  setOpen: any;
  setValue: any;
  setItems: any;
  multiple?: boolean;
  mode?: "BADGE" | "DEFAULT" | "SIMPLE";
  onClose?: any;
  onOpen?: any;
}

export default function CustomDropDown({
  open,
  value,
  placeholder,
  items,
  setOpen,
  setValue,
  setItems,
  multiple,
  mode,
  onClose,
  onOpen,
  ...rest
}: CustomDropDownProps) {

  return (
    <View style={{ marginBottom: 16, marginTop: 6, zIndex: 2  }}>
      <DropDownPicker
        open={open}
        value={value}
        items={items}
        setOpen={setOpen}
        setValue={setValue}
        placeholder={placeholder}
        setItems={setItems}
        multiple={multiple ?? false}
        mode={"BADGE" ?? "SIMPLE"}
        onOpen={onOpen}
        onClose={onClose}
        style={{
          borderColor: themes.colors.gray1,
          height: 56
        }}
        placeholderStyle={{
          color: "rgba(96, 93, 102, 1)",
          fontSize: 16
        }}
        dropDownContainerStyle={{
          borderColor: "rgba(96, 93, 102, 1)"
        }}
        {...rest}
      />
    </View>
  );
}
